import type React from 'react';

import { Badge } from '@change/ds-core-ui/Badge';

export const PostalCodeValue: React.FC<{ postalCode: string }> = ({ postalCode }) => {
	return <Badge label={postalCode} size="small" variant="neutral" />;
};
